import { trackLeadConversion } from './tracking';

// Saves a website enquiry; throws if the server did not accept it.
export const submitInquiry = async (payload, source) => {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/inquiries`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...payload, eventType: payload.eventType || 'Wedding Inquiry', source }),
  });
  if (!res.ok) throw new Error(`Inquiry failed (${res.status})`);
  trackLeadConversion({ source, eventType: payload.eventType });
  return res.json();
};
